import { useState, useEffect, useMemo } from 'react';
import { DgtPdOrderPicklist } from '../models'
import { getDates } from '../utilities/Format'
import { PicklistStatus } from '../constants/EnumType'
import { 
  getReleasedOrderPicklists,
  getRequestedOrderPicklists
} from '../states/PicklistAction'

export default function useApprovedOrderPicklist(
  status: string,
  orderType: string,
  dateFrom: Date,
  dateTo: Date,
  searchByOrder: string,
  division: string
) : DgtPdOrderPicklist[] {
  const [picklists, setPicklists] = useState<DgtPdOrderPicklist[]>([]);

  useEffect(() => {
    const periodDates = getDates(dateFrom, dateTo)
    // sorted date LIFO (Last In First Out)
    periodDates.sort((d1, d2) => d2.localeCompare(d1))
    
    Promise.allSettled(periodDates.map(date => {
      if (status === PicklistStatus.PD_RELEASED) {
        return getReleasedOrderPicklists(date, division, orderType)
      } else if (status === PicklistStatus.PD_REQUESTED) {
        return getRequestedOrderPicklists(date, division, orderType)
      }
      return Promise.reject(`Picklist Status not supported : ${status}`)
    })).then(results => {
      const totalPicklists = (results
        .filter(res => res.status === 'fulfilled') as PromiseFulfilledResult<DgtPdOrderPicklist[]>[])
        .reduce((prev, cur) => [...prev, ...cur.value], [] as DgtPdOrderPicklist[])
      setPicklists(totalPicklists)
    })
    .catch(err => console.error(err))
  }, [ status, orderType, dateFrom, dateTo, division ]);

  const filteredPicklists = useMemo(() => picklists.filter(pl => pl.pk.includes(searchByOrder)), [ searchByOrder, picklists ])
  return filteredPicklists
}